// frontend/src/pages/ContactRequests.js
import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import ContactRequestsList from '../components/ContactRequestsList';
import TutorialModal from '../components/TutorialModal';
import { hasSeenTutorial } from '../utils/tutorialData';

const ContactRequests = () => {
    const { profile, loadingProfile } = useOutletContext();
    const [showTutorial, setShowTutorial] = useState(!hasSeenTutorial('contact-requests'));

    if (loadingProfile) {
        return (
            <div className="flex items-center justify-center p-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        );
    }

    if (!profile || (profile.role !== 'admin' && profile.role !== 'gruppenleiter')) {
        return (
            <div className="container mx-auto p-4">
                <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
                    <h2 className="text-xl font-bold text-red-600 mb-2">Zugriff verweigert</h2>
                    <p className="text-red-500">Sie müssen Admin oder Gruppenleiter sein, um diese Seite zu sehen.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto p-4 max-w-6xl animate-fade-in">
            {showTutorial && (
                <TutorialModal pageId="contact-requests" onClose={() => setShowTutorial(false)} />
            )}
            <div className="mb-8">
                <h1 className="text-display-small font-bold text-surface-on mb-2">Kontaktanfragen</h1>
                <p className="text-body-large text-surface-onVariant">Verwalte eingehende Kontaktanfragen</p>
            </div>

            <div className="md3-card-elevated p-6">
                <ContactRequestsList />
            </div>
        </div>
    );
};

export default ContactRequests;
